import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { BreadcrumbItem, Col, Row } from "reactstrap";

const BreadcrumbWithLink = props => {
  const { title, breadcrumbItems, style } = props;

  return (
    <Row
      style={{
        ...style,
      }}
    >
      <Col xs="12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-0 font-size-18">{title}</h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              {breadcrumbItems.map((item, index) => {
                return (
                  <BreadcrumbItem key={index}>
                    <Link to={item.link || "#"}>{item.name}</Link>
                  </BreadcrumbItem>
                );
              })}
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  );
};

BreadcrumbWithLink.propTypes = {
  title: PropTypes.any,
  breadcrumbItems: PropTypes.array,
  style: PropTypes.any,
};

BreadcrumbWithLink.defaultProps = {
  breadcrumbItems: [],
  title: "",
};

export default BreadcrumbWithLink;
